import { render, staticRenderFns } from "./SignatureTemplate.vue?vue&type=template&id=1fc48a54&"
import script from "./SignatureTemplate.vue?vue&type=script&lang=js&"
export * from "./SignatureTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SignatureTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports